import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { colors, breakpoints } from '../styles/utilities/settings';
import { button } from '../styles/utilities/elements';
import { AppContext } from '../App';
import { industries } from '../Content';

const recaptchaRef = React.createRef();

const FirstForm = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [error, setError] = useState(false);
  const [optin, setOptin] = useState(false);

  const {
    userZip,
    setUserZip,
    userEmail,
    setUserEmail,
    userIndustry,
    setUserIndustry,
    setScoreWindow,
  } = useContext(AppContext);

  const emailSignUp = () => {
    /* eslint-disable no-undef */
    if (optin) {
      const data = new XMLHttpRequest();
      data.open(
        'POST',
        `https://pestpressureriskapi.azurewebsites.net/api/PostEmailToSalesforce/${userEmail}`,
        true
      );
      data.send(null);
    }
  };

  return (
    <Form>
      <h2>Get Your Local Pest Risk Score</h2>
      <form>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey="6LdB0dUUAAAAAGY08FDDqfHwWCQoymR1MIUpsokG"
        />
        <fieldset>
          <div className="app-form-inner">
            <label htmlFor="zip">
              Your Zip Code
              <input
                onChange={(e) => {
                  setUserZip(e.target.value);
                }}
                value={userZip}
                required
                name="zip"
                type="text"
              />
              {error && !userZip && <Error>Please enter zip code</Error>}
            </label>
            <label htmlFor="industry">
              Your Industry
              <div
                className="app-form-input"
                onKeyPress={(e) => {
                  e.key === 'Enter' && setOpenDrawer(!openDrawer);
                }}
                onClick={() => setOpenDrawer(!openDrawer)}
              >
                <input
                  required
                  name="industry"
                  readOnly
                  type="text"
                  value={
                    (userIndustry && userIndustry.label) || 'Select Industry'
                  }
                />
                <span className="arrow">
                  <span />
                  <span />
                </span>
                {openDrawer !== false && (
                  <ul>
                    {industries.map((ind) => (
                      <li key={Math.random()}>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenDrawer(!openDrawer);
                            setUserIndustry(ind);
                          }}
                        >
                          {ind.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {error && !userIndustry && (
                <Error>Please select an industry</Error>
              )}
            </label>
            <label htmlFor="emailaddress">
              Your Email Address
              <input
                onChange={(e) => {
                  setUserEmail(e.target.value);
                }}
                value={userEmail}
                required
                name="emailaddress"
                type="email"
              />
              {error && !userEmail && <Error>Please enter a valid email</Error>}
            </label>
          </div>
        </fieldset>
        <div className="app-form-submit">
          <div className="copy">
            <label htmlFor="optin">
              <input
                type="checkbox"
                name="optin"
                id="optin"
                onChange={() => {
                  setOptin(!optin);
                }}
              />
              <span>
                <strong>
                  Do you want to receive the latest news, promotional offers and
                  other information from Ecolab?
                </strong>
                <div style={{ display: 'block', margin: '10px 0' }} />
                By checking this box, you are agreeing that Ecolab may contact
                you via email with promotional offers, updates, and other
                information. If you wish to continue your customer relationship
                without receiving marketing communication, you may submit your
                information without checking this box. See our&nbsp;
                <a href="https://www.ecolab.com/privacy-policy">
                  Privacy Policy
                </a>
                .
              </span>
            </label>
          </div>
          <input
            id="getScore"
            type="submit"
            value="Get Score"
            disabled={userZip && userIndustry ? false : error}
            onClick={(e) => {
              e.preventDefault();
              if (userZip && userEmail && userIndustry) {
                emailSignUp();
                setScoreWindow(true);
              } else {
                setError(true);
              }
            }}
          />
        </div>
      </form>
    </Form>
  );
};

export default FirstForm;

const Error = styled.div`
  color: ${colors.red};
  margin-top: 10px;
`;

export const Form = styled.div`
  background-color: ${({ blue }) =>
    blue ? colors.lightBlue : colors.lightGray};
  padding: 30px;
  text-align: left;

  form {
    padding: 0;
  }

  fieldset {
    margin: 0 -30px 10px 0;
    padding: 0;
    border: 0;
  }

  .app-form-inner {
    @media screen and (min-width: ${breakpoints.ipadPort}px) {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  label {
    display: block;
    padding-right: 30px;
    font-size: 14px;

    @media screen and (min-width: ${breakpoints.ipadPort}px) {
      width: 100%;
    }

    @media screen and (max-width: ${breakpoints.ipadPort - 1}px) {
      margin-bottom: 15px;
    }
  }

  textarea,
  input[type='text'],
  input[type='number'],
  input[type='email'] {
    margin-top: 10px;
    appearance: none;
    border: 1px solid ${colors.middleGray};
    padding: 12.5px;
    box-sizing: border-box;
    display: block;
    width: 100%;
    border-radius: 3px;
    position: relative;
    background-color: ${colors.white};
    font-size: 12px;
    color: ${colors.darkerGray};
  }

  .app-form-input {
    position: relative;
    padding: 0;

    > span {
      padding: 12.5px;
    }

    span {
      display: block;
      height: 100%;
      cursor: pointer;
      line-height: 16px;
      position: relative;

      &.arrow {
        position: absolute;
        top: 0px;
        right: ${({ blue }) => (blue ? '30px' : '0')};
        height: 20px;
        width: 30px;
        box-sizing: content-box;

        span {
          height: 1px;
          width: 10px;
          background-color: ${colors.gray};
          display: block;
          transform: rotate(-45deg);
          position: relative;
          top: 9px;
          left: 12px;

          + span {
            margin: -1px 0 0 -5px;
            transform: rotate(45deg);
          }
        }
      }
    }

    ul {
      position: absolute;
      top: 100%;
      left: -1px;
      width: calc(100% ${({ blue }) => (blue ? '- 30px' : '+ 2px')});
      background-color: ${colors.white};
      margin: 0 !important;
      box-sizing: border-box;
      list-style: none !important;
      box-shadow: 0px 20px 10px -20px;
      border-left: 1px solid ${colors.middleGray};
      border-right: 1px solid ${colors.middleGray};
      border-bottom: 1px solid ${colors.middleGray};
      z-index: 1;

      a {
        display: block;
        text-decoration: none;
        color: ${colors.black};
        padding: 10px;
        cursor: pointer;

        &:hover {
          background-color: ${colors.lightGray};
        }
      }
    }
  }

  .app-form-submit {
    display: flex;
    align-items: flex-start;

    @media screen and (max-width: ${breakpoints.ipadPort - 1}px) {
      flex-direction: column;
    }

    @media screen and (min-width: ${breakpoints.ipadPort}px) {
      justify-content: space-between;
    }

    .copy {
      width: 100%;
      margin-top: 10px;

      @media screen and (min-width: ${breakpoints.ipadPort}px) {
        max-width: 800px;
        padding-right: 30px;
      }

      label {
        position: relative;
        padding-left: 30px;
        margin-bottom: 30px;
        font-size: 1em;
        box-sizing: border-box;
      }

      [type='checkbox'] {
        position: absolute;
        top: 2px;
        left: 0;
      }
    }

    [type='submit'] {
      display: inline-block;
      width: auto;
      ${button};

      @media screen and (min-width: ${breakpoints.ipadPort}px) {
        margin-top: 20px;
      }

      &[disabled] {
        background: ${colors.gray};
      }
    }
  }

  .app-form-copy {
    margin-top: 30px;

    p {
      font-size: 14px;
      margin-bottom: 10px;
    }

    label {
      &:before {
        margin-top: 3px;
      }
    }
  }

  .fieldset {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    padding: 0;
    border: 0;

    .field {
      box-sizing: content-box;
      width: 100%;
      margin-bottom: 20px;

      label,
      input,
      textarea {
        width: calc(100% - 30px);
      }

      label {
        font-size: 12px;
      }

      &.half {
        @media screen and (min-width: ${breakpoints.mobile}px) {
          width: 50%;
        }
      }

      &.fourth {
        @media screen and (min-width: ${breakpoints.mobile}px) {
          width: 25%;
        }
      }
    }
  }

  .app-form-checkbox {
    width: 48%;
    display: inline-block;
    margin-bottom: 15px;

    &.agreement {
      margin: 30px 0;
    }

    label {
      width: 100%;
      padding: 5px 0 0 25px;
      position: relative;
      cursor: pointer;

      &:before {
        content: '';
        display: block;
        width: 15px;
        height: 15px;
        background-color: ${colors.white};
        border: 1px solid ${colors.middleGray};
        position: absolute;
        top: 3px;
        left: 0;
        border-radius: 3px;
      }

      p {
        margin: 0;
      }
    }

    input {
      height: 0;
      position: absolute;
      overflow: hidden;
      width: 0;
      opacity: 0;

      &:checked {
        + label {
          &:before {
            background-color: ${colors.blue};
          }
        }
      }
    }
  }
`;
